module.exports = __webpack_public_path__ + "static/media/game1.de1ae56a.svg";